// The Library at /: Main.dc.html at laptop width, PhoneLibrary.dc.html at phone width.
// While staff view as a member it's read-only: the 1 line at the top, Hide does nothing, and opening
// the bell marks nothing read (lib/viewAs.jsx). Add to calendar and Join write nothing, so they work.
// After a login from the property strategy report's link, a line at the top opens the report (library/ReportReady.jsx).
import { useCallback, useEffect, useState } from 'react'
import { SITE, setTitle } from '../config/site.js'
import { useMember } from '../app/member.jsx'
import { useLibraryModel } from '../library/useModel.js'
import { usePhone } from '../lib/media.js'
import { downloadIcs } from '../lib/calendar.js'
import { useViewingAs, ReadOnlyNote } from '../lib/viewAs.jsx'
import { Header } from '../shell/Header.jsx'
import { Footer } from '../shell/Shell.jsx'
import LibraryLaptop from '../library/LibraryLaptop.jsx'
import { PaymentBanner } from '../shell/PaymentBanner.jsx'
import LibraryPhone from '../library/LibraryPhone.jsx'
import { ReportReady } from '../library/ReportReady.jsx'
import '../styles/shell.css'
import '../styles/library.css'

export default function Library() {
  const { me, lib, refreshLibrary, refreshLevels, hide, markRead } = useMember()
  const model = useLibraryModel()
  const phone = usePhone()
  const viewingAs = useViewingAs()
  // the sessions added to their calendar on this visit, by id: Next up's and Coming up's
  const [added, setAdded] = useState(() => new Set())

  useEffect(() => { setTitle('Your library') }, [])
  useEffect(() => { refreshLibrary() }, [refreshLibrary])
  // where they stand on a mastermind's tile: asked for each load of the rows while the Library is open, never waited on
  // (app/member.jsx refreshLevels), and only here, so a page that loads the rows for its header reads no log more
  const loadId = lib.data?.loadId
  useEffect(() => { if (loadId) refreshLevels(lib.data) }, [loadId, refreshLevels]) // eslint-disable-line react-hooks/exhaustive-deps

  const addCal = useCallback(cal => {
    downloadIcs(cal)
    setAdded(prev => new Set(prev).add(cal.uid))
  }, [])
  const onHide = viewingAs ? () => {} : hide
  const note = viewingAs ? <ReadOnlyNote /> : null

  return (
    <div className="lib-page">
      <Header model={model} person={me.person} phone={phone} onOpenBell={viewingAs ? undefined : markRead} />
      {model && <PaymentBanner text={model.banner} target={model.bannerFor} phone={phone} />}
      {model && <ReportReady personId={me.person?.id} phone={phone} viewingAs={viewingAs} />}
      {model && (phone
        ? <LibraryPhone model={model} onHide={onHide} onAddCal={addCal} added={added} viewingAs={viewingAs} note={note} />
        : <LibraryLaptop model={model} onHide={onHide} onAddCal={addCal} added={added} viewingAs={viewingAs} note={note} />)}
      {!model && lib.status === 'error' && (
        <main className="sh-main">
          <h1 className="sh-h1">Your library didn't load</h1>
          <p className="sh-lede">Check your connection and try again. If it keeps happening, email {SITE.helpEmail}.</p>
          <p className="sh-actions-row"><button type="button" className="btn btn-ink" onClick={refreshLibrary}>Try again</button></p>
        </main>
      )}
      {!model && lib.status !== 'error' && <main className="lib-loading" aria-busy="true" />}
      <Footer phone={phone} />
    </div>
  )
}
